// HIER KOMEN ALLE NIEUWE PACKAGES/OUDE BOWER PACKAGES
require('foundation-sites');
require('bxslider');
require('jquery.animate-number');
require('./lib/jquery.magnific-popup.min.js');
